import {
    LOGOUT,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    REFRESH_TOKEN,
    AUTH_VERIFICATION_SUCCESS,
    AUTH_VERIFICATION_FAIL,
    CLEAR_AUTH_VERIFICATION,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAIL, CLEAR_CHANGE_PASSWORD, ENJOY_BOARD_TOKEN, ENJOY_BOARD_TOKEN_FAIL
} from "../actions/actionTypes";

import TokenService from "../../../services/token.service";

const token = TokenService.getToken()
const refreshToken = TokenService.getLocalRefreshToken()

const initialState = token ?
    {
        token: token,
        refreshToken: refreshToken,
        userId: 0,
        isLogin: true,
        isConfirmedStatus: 0,
        changedPasswordStatus: 0,
        enjoyBoardToken:"",
        message:""
    } :
    {
        token: null,
        refreshToken: null,
        userId: 0,
        isLogin: false,
        isConfirmedStatus: 0,
        changedPasswordStatus: 0,
        enjoyBoardToken:"",
        message: ""
    }

const loginReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return {
                ...state,
                token: action.payload.token,
                refreshToken: action.payload.refreshToken,
                userId: action.payload.userId,
                isLogin: true,
                message: initialState.message
            }
        case AUTH_VERIFICATION_SUCCESS  :
            return {
                ...state,
                isConfirmedStatus: action.payload.isConfirmedStatus
            }
        case AUTH_VERIFICATION_FAIL:
            return {
                ...state,
                isConfirmedStatus: action.payload.isConfirmedStatus
            }
        case CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                changedPasswordStatus: action.payload.changedPasswordStatus
            }
        case ENJOY_BOARD_TOKEN:
            return {
                ...state,
                enjoyBoardToken: action.payload.enjoyBoardToken
            }
        case ENJOY_BOARD_TOKEN_FAIL :
            return {
                ...state,
                enjoyBoardToken:action.payload.enjoyBoardToken
            }
        case CHANGE_PASSWORD_FAIL:
            return {
                ...state,
                changedPasswordStatus: action.payload.changedPasswordStatus
            }
        case CLEAR_AUTH_VERIFICATION :
            return {
                ...state,
                isConfirmedStatus: 0
            }
        case CLEAR_CHANGE_PASSWORD :
            return {
                ...state,
                changedPasswordStatus: 0
            }
        case LOGIN_FAIL:
            return {
                ...state,
                isLogin: false,
                token: null,
                refreshToken: null,
                userId: null,
                message:action.payload.message,
            }
        case LOGOUT:
            return {
                ...state,
                isLogin: false,
                token: null,
                refreshToken: null,
                userId: 0,
            }
        case REFRESH_TOKEN:
            return {
                ...state,
                token: action.payload.token,
                refreshToken: action.payload.refreshToken,
                isLogin: true
            };

        default:
            return {
                ...state
            }
    }
}

export default loginReducer;